import { render, staticRenderFns } from "./BillingMenuBtns.vue?vue&type=template&id=c735fd82&scoped=true&"
import script from "./BillingMenuBtns.vue?vue&type=script&lang=js&"
export * from "./BillingMenuBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c735fd82",
  null
  
)

export default component.exports